import { InputMentionValue } from "@src/types/intelligence-search";
import { useState } from "react";

export const useManageAddNewMetric = ({
    dryRunCheck,
}: {
    dryRunCheck: ({
        formula,
        alias,
        mentionMeta,
        editProps,
    }: {
        formula: string;
        alias: string;
        mentionMeta: InputMentionValue;
        editProps?: {
            id: string;
        };
    }) => {
        check: () => Promise<any> | undefined;
        onSuccess: (fieldType: string) => void;
    };
}) => {
    const [loading, setLoading] = useState(false);

    const handleConfirmCustomMetric = async (
        formula: string,
        alias: string,
        mentionMeta: InputMentionValue,
        onSuccess?: () => void,
        onError?: (error: { field: "formula" | "alias"; error: string[] }[]) => void,
        editProps?: {
            id: string;
        },
    ) => {
        setLoading(true);
        const { check, onSuccess: onDryRunCheckSuccess } = dryRunCheck({ formula, alias, mentionMeta, editProps });
        try {
            const res = await check();
            const customMetricFieldType = res.schema?.find((item: any) => item.name === alias)?.field_type;

            if (!customMetricFieldType) {
                onError?.([{ field: "formula", error: [`Invalid Custom Metric`] }]);
                return;
            }
            onDryRunCheckSuccess?.(customMetricFieldType);
            onSuccess?.();
        } catch (error: any) {
            onError?.([{ field: "formula", error: error?.response?.data?.detail?.errors ?? [] }]);
        } finally {
            setLoading(false);
        }
    };
    return {
        loading,
        handleConfirmCustomMetric,
    };
};
